export default {
  click_on_save_template: {
    evid: 1561,
    src: 38,
    fields: {
      is_first_template_save: 'boolean',
      origin: 'string',
    },
  },
  post_save_modal: {
    evid: 1563,
    src: 38,
    fields: {
      is_first_template_save: 'boolean',
      action: 'string',
    },
  },
  hover_on_publish_template: {
    evid: 1562,
    src: 38,
    fields: {
      is_published_template: 'boolean',
    },
  },
  click_on_publish_template: {
    evid: 1559,
    src: 38,
    fields: {
      is_first_template_publish: 'boolean',
      origin: 'string',
    },
  },
  post_publish_modal: {
    evid: 1564,
    src: 38,
    fields: {
      is_first_template_publish: 'boolean',
      action: 'string',
    },
  },
} as const;
